import logo from './wbnb.jpeg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Which BNB Test Page 
        </p>
      </header>
    </div>
  );
}

export default App;
